module.exports = __webpack_public_path__ + "media/images/pages/fcr-case/case-10-2df1bb08bc13c3c3142ffd0ec72d8fd9.png";